import DaumPostcode, { type Address } from "react-daum-postcode";
import Modal from "./base.modal";
import type { ModalComponentProps } from "../../types/modal.types";

interface ModalProps extends ModalComponentProps {
  onComplate?: (address: Address) => void;
}

const PostcodeModal = ({ id, onClose, onComplate }: ModalProps) => {
  return (
    <Modal id={id} close={onClose}>
      <DaumPostcode onComplete={onComplate} onClose={onClose} />
    </Modal>
  )
}

export default PostcodeModal;